<template>
  <div>
         <div class="mx-5 p-5 d-flex justify-space-between">
      <h5>Edit Address </h5>
    </div>
    <v-card color="#F6F8FC" flat class="px-5">
      <v-form v-model="valid" class="py-8">
        <v-container >
              <v-text-field
            v-model="Address"
            label="Address"
            required
          ></v-text-field>
          <v-text-field
            v-model="firstname"
            :counter="10"
            label="First name"
            required
          ></v-text-field>
          <v-text-field
            v-model="lastname"
            :counter="10"
            label="Last name"
            required
          ></v-text-field>
           <v-text-field
            v-model="PhoneNumber"
            :counter="15"
            label="Phone"
            required
          ></v-text-field>

          <v-text-field
            v-model="email"
            :rules="emailRules"
            label="E-mail"
            required
          ></v-text-field>
        </v-container>
      </v-form>
             <div class="d-flex justify-end ">
      <v-btn
        color="#C4C4C4"
        class="white--text py-5 px-8 mb-7"
        depressed
        @click="close()"
        ><span class="text_style">Cancel</span>
      </v-btn>
      <v-btn
        color="primary"
        class="white--text py-5 px-8 ml-4"
        depressed
        :disabled = "btnloader"
        @click="save()"
        ><span v-if="btnloader != true"> Save </span>
        <v-progress-circular
          indeterminate
          size="20"
          v-else
          class="px-5"
          color="white"
          v-show="btnloader"
        ></v-progress-circular
      ></v-btn>
    </div>
    </v-card>
  </div>
</template>

<script>
// import VueDropify from "vue-dropify";

// import vue2Dropzone from "vue2-dropzone";
// import "vue2-dropzone/dist/vue2Dropzone.min.css";


export default {
  name: "editusercomponent",
  

  data() {
    return {
      btnloader: false,
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 200, 
        addRemoveLinks: true,
      },
      valid: false,
      firstname: "",
      lastname: "",
      PhoneNumber: "",
      email: "",
      Address:"",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      role: ["super admin", "admin"],
    };
  },
  methods: {
         close() {
      this.$emit("close");
    },
    save() {
      setTimeout(() => {
        this.btnloader = true;
      }, 100);
      setTimeout(() => {
        this.close();
        this.btnloader = false;
        this.snackbar = true;
      }, 2000);
    },
  },
};
</script>

<style scoped>
.vue-dropzone {
    padding: 0;
    background: transparent;
    border-style: dashed;
}
</style>


